import React from 'react';
import ViewHeader from '../../components/ViewHeader';

export const CartHeader = ({
  order,
  restaurant_profile,
  onViewExistingOrder,
}) => {
  const isExistingOrder = order !== null && !order?.is_single_session;
  const orderTypeText = restaurant_profile?.config?.use_order_lang
    ? 'order'
    : 'tab';

  return (
    <div className="flex justify-between items-center mt-4">
      <ViewHeader
        title={`${
          isExistingOrder
            ? `Add to your ${orderTypeText}`
            : `Start your ${orderTypeText}`
        }`}
        className="text-left px-4"
      />
      {isExistingOrder && (
        <div className="px-4">
          <button
            onClick={onViewExistingOrder}
            type="button"
            className="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded-full shadow-sm text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Table {order?.table_number}
          </button>
        </div>
      )}
    </div>
  );
};
